import { mapApiDataToProductPage } from '@/lib/cms-mappers';
import { locales } from '@/config/locales';

import type { FProductPageTemplateProps } from '@/components/templates/FProductPageTemplate.vue';
import type { ProductPageType } from '@/composables/useProductPageProps';

/**
 * Returns product faq items from CMS (Strapi)
 */
export async function useCmsProductPage(
  productPageType: ProductPageType
): UseCmsResponse<Pick<FProductPageTemplateProps, 'faqItems'>> {
  const { data, error, pending, refresh } = await useStrapi(
    `product-${productPageType}`,
    {
      localesSubset: locales,
      queryParams: {
        populate: 'faq_items',
      },
    }
  );
  const mappedData = computed(() => mapApiDataToProductPage(data.value?.data));

  return { data: mappedData, error, pending, refresh };
}
